import React from "react";
import { NavLink } from "react-router-dom";
import IconFriends from "../../components/SvgIcons/IconFriends";
import IconTandomTimeline from "../../components/SvgIcons/IconTandomTimeline";
import IconMyFeed from "../../components/SvgIcons/IconMyFeed";
import IconSearch from "../../components/SvgIcons/IconSearch";
import IconNotifications from "../../components/SvgIcons/IconNotifications";
import IconRequestSent from "../../components/SvgIcons/IconRequestSent";
import IconRequestReceived from "../../components/SvgIcons/IconRequestReceived";

export default function AdminNavigation() {
  return (
    <div className="admin-menu">
      <ul>
        <li>
          <NavLink
            to="/dashboard"
            className={({ isActive }) => (isActive ? "active" : "")}
            end
          >
            <IconFriends /> Friends
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/tandom-timeline"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <IconTandomTimeline /> Tandom Timeline
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/my-feed"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <IconMyFeed /> My Feed
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/search"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <IconSearch /> Search
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/notifications"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <IconNotifications /> Notifications
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/request-sent"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <IconRequestSent /> Request Sent
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/request-received"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <IconRequestReceived /> Request Received
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
